import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';

@Component({
    selector: 'due-date-filter-drop-down',
    templateUrl: './due-date-filter-drop-down.component.html',
    styleUrls: ['./due-date-filter-drop-down.component.scss'],
})
export class DueDateFilterDropDown implements OnInit, OnChanges {
    openedFlyout = false;
    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    @Input() selectedYears: number[] = [];
    @Input() translationKeyFilterName: string = 'aumico_pm_tasks_due_date_filter_label';

    @Output() filterChange = new EventEmitter<number[]>();

    options: number[] = [];
    selectedOptionIds: number[] = [];

    constructor() {}

    ngOnInit(): void {
        this.generateOptions();
        this.selectedOptionIds = [...(this.selectedYears || [])];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedYears'] && changes['selectedYears'].currentValue) {
           this.selectedOptionIds = [...changes['selectedYears'].currentValue];
        }
    }

    private generateOptions(): void {
        const currentYear = new Date().getFullYear();
        this.options = [];
        // Current year down to -5 years (6 options total)
        for (let i = 0; i <= 5; i++) {
            this.options.push(currentYear - i);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 8,
            right: rect.right,
            left: rect.left,
        };

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    onPeriodSelection(id: number, checked: boolean): void {
        if (checked) {
            this.selectedOptionIds.push(id);
        } else {
            this.selectedOptionIds = this.selectedOptionIds.filter((optionId) => optionId !== id);
        }
    }

    toggleUserSelection(id: number): void {
        const index = this.selectedOptionIds.indexOf(id);
        if (index > -1) {
            this.selectedOptionIds.splice(index, 1);
        } else {
            this.selectedOptionIds.push(id);
        }
    }

    applyFilter(): void {
        this.filterChange.emit(this.selectedOptionIds);
        this.closeFlyout();
    }

    clearFilter(): void {
        this.selectedOptionIds = [];
        this.filterChange.emit([]);
        this.closeFlyout();
    }
}

